// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1Y_LJ","headerLogo":"header_headerLogo__2GdK4","logoImg":"header_logoImg__3FABV","bgPartial":"header_bgPartial__MXMaD","banner":"header_banner__8k-up"};